"use client";
import React, { lazy } from "react";
import { BXH_LEAGUES } from "../../../contants";
import {Link} from '@/lib/target';
import { convertToLeagueMatchFormat } from "@/utils/convertToLeagueMatchFormat";
const BangkeoHotLeague = lazy(() => import('@/components/client/BangkeoHotLeague'));
const NoDataWithLink = lazy(() => import('@/components/client/NoDataWithLink'));

const BangkeoHotMatches = ({ matches }) => {
  const hotLeagueIds = BXH_LEAGUES.map((league) => league.id);

  const filteredMatch = matches?.filter((match) =>
    hotLeagueIds.includes(match?.league?.id)
  );

  const leagues = convertToLeagueMatchFormat(filteredMatch)

  if (!leagues.length) {
    return (
      <NoDataWithLink>
        <span>
          Hôm nay chưa có trận đấu nào. Khám phá thêm các trận qua Lịch thi đấu
          {
            <Link
              className="text-medium-blue hover:cursor-pointer"
              href={"/lich-thi-dau"}
            >
              &nbsp;tại đây.
            </Link>
          }
        </span>
      </NoDataWithLink>
    );
  }

  return <BangkeoHotLeague type="tc" leagueInfos={leagues} />;
};

export default BangkeoHotMatches;
